import React, { useEffect, useState } from "react";
import Card from "components/Card/Card";

import {
  Text,
  Flex,
  FormControl,
  FormLabel,
  Input,
  FormErrorMessage,
  Button,
  Textarea,
  RadioGroup,
  Stack,
  SimpleGrid,
  AbsoluteCenter,
  Center,
  useColorModeValue,
  useColorMode,
  Skeleton,
} from "@chakra-ui/react";
import { Field, Form, Formik } from "formik";
import CustomCheckbox from "../../../components/Checkbox/CustomCheckbox";
import ReactSelect from "react-select";
import { sluzby } from "../../../variables/general";
import axios from "axios";
import apiUrl from "../../../variables/api";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import darkStyles from "variables/darkStyles";
import Creatable from "react-select/creatable";

import locations from "variables/locations";

const initialValues = {
  dateTime: new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, -8),
  location: "",
  conditions: "",
  vehicle: "",
  vehicleDriver: "",
  peoplesNumber: "",
  privileged: "",
  accidentCause: "",
  circumstances: "",
  vehicleDamage: "",
  rescuersKilled: "",
  rescuersInjured: "",
  bystandersKilled: "",
  bystandersInjured: "",
};

const validate = (values) => {
  const errors = {};
  const requiredFields = Object.keys(initialValues);

  requiredFields.forEach((field) => {
    if (!values[field] && values[field] !== 0) {
      errors[field] = "To pole jest obowiazkowe";
    }
  });

  return errors;
};

function Page() {
  const [vehicles, setVehicles] = useState([]);
  useEffect(() => {
    axios
      .get(apiUrl + "/data/vehicles", {
        headers: { "x-access-token": localStorage.getItem("token") },
      })
      .then((response) => {
        const vehicles = response.data;
        const formattedData = vehicles.reduce((acc, item) => {
          const existingUnit = acc.find((unit) => unit.unit === item.unit);
          if (existingUnit) {
            existingUnit.vehicles.push(item.operationalNumber);
          } else {
            acc.push({ unit: item.unit, vehicles: [item.operationalNumber] });
          }
          return acc;
        }, []);
        const formattedOptions = formattedData.map((unit) => ({
          label: unit.unit,
          options: unit.vehicles.map((vehicle) => ({
            label: vehicle,
            value: vehicle,
          })),
        }));
        setVehicles(formattedOptions);
        console.log(formattedData);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);
  const [peoples, setPeoples] = useState([]);
  useEffect(() => {
    axios
      .get(apiUrl + "/data/peoples", {
        headers: { "x-access-token": localStorage.getItem("token") },
      })
      .then((response) => {
        console.log(response.data);
        setPeoples(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const [formData, setFormData] = useState(initialValues);
  const formikRef = React.useRef();
  const handleSubmit = (values, { setSubmitting, resetForm }) => {
    console.log("Dane formularza", values);

    setFormData(values);
    axios
      .post(apiUrl + "/data/vehicleAccident", values, {
        headers: { "x-access-token": localStorage.getItem("token") },
      })
      .then((response) => {
        if (response.data.success) {
          formikRef.current.resetForm();
          formikRef.current.setSubmitting(false);
          return toast.success("Pomyślnie wysłano meldunek o wypadku pojazdu");
        } else {
          formikRef.current.setSubmitting(false);
          return toast.error(
            "Napotkano błąd podczas wysyłania meldunku o wypadku pojazdu"
          );
        }
      })
      .catch((error) => {
        console.error(error);
        formikRef.current.setSubmitting(false);
        toast.error("Napotkano błąd podczas połączenia z API");
      });
  };
  const { colorMode } = useColorMode();

  const reasons = [
    {
      label: "alkohol/narakotyki",
      value: "alkohol/narakotyki",
      color: "red",
    },
    {
      label: "leki",
      value: "leki",
      color: "red",
    },
    {
      label: "wymuszenie pierwszeństwa przejazdu",
      value: "wymuszenie pierwszeństwa przejazdu",
      color: "red",
    },
    {
      label: "przekroczenie obowiązującej szybkości",
      value: "przekroczenie obowiązującej szybkości",
      color: "red",
    },
    {
      label: "nieostrożność",
      value: "nieostrożność",
      color: "red",
    },
    {
      label: "nieprzestrzeganie przepisów",
      value: "nieprzestrzeganie przepisów",
      color: "red",
    },
    {
      label: "przemęczenie",
      value: "przemęczenie",
      color: "red",
    },
    {
      label: "wady techniczne",
      value: "wady techniczne",
      color: "red",
    },
    {
      label: "wina innego kierowcy",
      value: "wina innego kierowcy",
      color: "red",
    },
    {
      label: "przyczyna niezależna od kierowcy",
      value: "przyczyna niezależna od kierowcy",
      color: "red",
    },
    {
      label: "inna",
      value: "inna",
      color: "red",
    },
  ];

  return (
    <Flex flexDirection="column" pt={{ base: "120px", md: "75px" }}>
      <Card minH="125px">
        <Formik
          initialValues={initialValues}
          validate={validate}
          onSubmit={handleSubmit}
          innerRef={formikRef}
        >
          {({ isSubmitting, formik }) => (
            <Form>
              <SimpleGrid
                columns={{ sm: 1, md: 2, xl: 4 }}
                spacing="24px"
                mb="20px"
              >
                <Field name="dateTime">
                  {({ field, form }) => (
                    <FormControl
                      id="dateTime"
                      isRequired
                      isInvalid={form.errors.dateTime && form.touched.dateTime}
                    >
                      <FormLabel>Data i godzina</FormLabel>
                      <Input
                        type="datetime-local"
                        {...field}
                        placeholder="Data i godzina"
                      />
                      <FormErrorMessage>
                        {form.errors.dateTime}
                      </FormErrorMessage>
                    </FormControl>
                  )}
                </Field>
                <Field name="location">
                  {({ field, form }) => (
                    <FormControl
                      id="location"
                      isRequired
                      isInvalid={form.errors.location && form.touched.location}
                    >
                      <FormLabel>Lokalizacja</FormLabel>
                      <Creatable
                          {...field}
                          options={locations}
                          placeholder="Wybierz..."
                          styles={darkStyles()}
                          value={form.values[field.name]}
                          onChange={(selectedOptions) => {
                            form.setFieldValue(field.name, selectedOptions);
                          }}
                          formatCreateLabel={(inputValue) =>
                            `Niestandardowa: ${inputValue}`
                          }
                        />
                      <FormErrorMessage>
                        {form.errors.location}
                      </FormErrorMessage>
                    </FormControl>
                  )}
                </Field>
                <Field name="conditions">
                  {({ field, form }) => (
                    <FormControl
                      id="conditions"
                      isRequired
                      isInvalid={
                        form.errors.conditions && form.touched.conditions
                      }
                    >
                      <FormLabel>Warunki atmosferyczne</FormLabel>
                      <Input {...field} placeholder="Warunki" />
                      <FormErrorMessage>
                        {form.errors.conditions}
                      </FormErrorMessage>
                    </FormControl>
                  )}
                </Field>
                <Field name="vehicle">
                  {({ field, form }) => (
                    <FormControl
                      id="vehicle"
                      isRequired
                      isInvalid={form.errors.vehicle && form.touched.vehicle}
                    >
                      <FormLabel>Pojazd</FormLabel>
                        <ReactSelect
                          {...field}
                          noOptionsMessage={() => "Brak dostępnych opcji"}
                          options={vehicles}
                          isLoading={vehicles.length === 0}
                          placeholder="Wybierz..."
                          styles={darkStyles()}
                          value={form.values.vehicle}
                          onChange={(selectedOptions) => {
                            form.setFieldValue(field.name, selectedOptions);
                          }}
                        />
                      <FormErrorMessage>{form.errors.vehicle}</FormErrorMessage>
                    </FormControl>
                  )}
                </Field>
                <Field name="vehicleDriver">
                  {({ field, form }) => (
                    <FormControl
                      id="vehicleDriver"
                      isRequired
                      isInvalid={
                        form.errors.vehicleDriver && form.touched.vehicleDriver
                      }
                    >
                      <FormLabel>Pojazd prowadził</FormLabel>
                        <ReactSelect
                          {...field}
                          noOptionsMessage={() => "Brak dostępnych opcji"}
                          options={peoples}
                          isLoading={peoples.length === 0}
                          placeholder="Wybierz..."
                          styles={darkStyles()}
                          value={form.values.vehicleDriver}
                          onChange={(selectedOptions) => {
                            form.setFieldValue(field.name, selectedOptions);
                          }}
                        />
                      <FormErrorMessage>
                        {form.errors.vehicleDriver}
                      </FormErrorMessage>
                    </FormControl>
                  )}
                </Field>
                <Field name="peoplesNumber">
                  {({ field, form }) => (
                    <FormControl
                      id="peoplesNumber"
                      isRequired
                      isInvalid={
                        form.errors.peoplesNumber && form.touched.peoplesNumber
                      }
                    >
                      <FormLabel>
                        Liczba osób przewożonych w pojeździe
                      </FormLabel>
                      <Input
                        type={"number"}
                        {...field}
                        placeholder="Liczba osób"
                      />
                      <FormErrorMessage>
                        {form.errors.peoplesNumber}
                      </FormErrorMessage>
                    </FormControl>
                  )}
                </Field>
                <Field name="privileged">
                  {({ field, form }) => (
                    <FormControl
                      id="privileged"
                      isRequired
                      isInvalid={
                        form.errors.privileged && form.touched.privileged
                      }
                    >
                      <FormLabel>
                        Czy pojazd w chwili wypadku byl uprzywilejowany
                      </FormLabel>
                      <RadioGroup name="incidentType" colorScheme="red">
                        <Stack direction="row">
                          <CustomCheckbox
                            key="TAK"
                            label="TAK"
                            isChecked={form.values.privileged == "TAK"}
                            onChange={() => {
                              form.setFieldValue(field.name, "TAK");
                            }}
                          />
                          <CustomCheckbox
                            key="NIE"
                            label="NIE"
                            isChecked={form.values.privileged == "NIE"}
                            onChange={() => {
                              form.setFieldValue(field.name, "NIE");
                            }}
                          />
                        </Stack>
                      </RadioGroup>
                      <FormErrorMessage>
                        {form.errors.privileged}
                      </FormErrorMessage>
                    </FormControl>
                  )}
                </Field>
                <Field name="accidentCause">
                  {({ field, form }) => (
                    <FormControl
                      id="accidentCause"
                      isRequired
                      isInvalid={
                        form.errors.accidentCause && form.touched.accidentCause
                      }
                    >
                      <FormLabel>Przypuszczalna przyczyna wypadku</FormLabel>
                      <ReactSelect
                        {...field}
                        noOptionsMessage={() => "Brak dostępnych opcji"}
                        options={reasons}
                        placeholder="Wybierz..."
                        styles={darkStyles()}
                        value={form.values.accidentCause}
                        onChange={(selectedOptions) => {
                          form.setFieldValue(field.name, selectedOptions);
                        }}
                      />
                      <FormErrorMessage>
                        {form.errors.accidentCause}
                      </FormErrorMessage>
                    </FormControl>
                  )}
                </Field>
                <Field name="circumstances">
                  {({ field, form }) => (
                    <FormControl
                      id="circumstances"
                      isRequired
                      isInvalid={
                        form.errors.circumstances && form.touched.circumstances
                      }
                    >
                      <FormLabel>Okolicznosci wypadku</FormLabel>
                      <Textarea {...field} placeholder="Okoliczności" maxH={"500px"}/>
                      <FormErrorMessage>
                        {form.errors.circumstances}
                      </FormErrorMessage>
                    </FormControl>
                  )}
                </Field>
                <Field name="vehicleDamage">
                  {({ field, form }) => (
                    <FormControl
                      id="vehicleDamage"
                      isRequired
                      isInvalid={
                        form.errors.vehicleDamage && form.touched.vehicleDamage
                      }
                    >
                      <FormLabel>Uszkodzenia pojazdu</FormLabel>
                      <Textarea {...field} placeholder="Uszkodzenia"maxH={"500px"} />
                      <FormErrorMessage>
                        {form.errors.vehicleDamage}
                      </FormErrorMessage>
                    </FormControl>
                  )}
                </Field>

                <SimpleGrid
                  columns={{ sm: 2, md: 2, xl: 2 }}
                  spacing="24px"
                  mb="20px"
                >
                  <Field name="rescuersKilled">
                    {({ field, form }) => (
                      <FormControl
                        id="rescuersKilled"
                        isRequired
                        isInvalid={
                          form.errors.rescuersKilled &&
                          form.touched.rescuersKilled
                        }
                      >
                        <FormLabel>Ratowników zabitych</FormLabel>
                        <Input
                          type={"number"}
                          {...field}
                          placeholder="Liczba"
                        />
                        <FormErrorMessage>
                          {form.errors.rescuersKilled}
                        </FormErrorMessage>
                      </FormControl>
                    )}
                  </Field>
                  <Field name="rescuersInjured">
                    {({ field, form }) => (
                      <FormControl
                        id="rescuersInjured"
                        isRequired
                        isInvalid={
                          form.errors.rescuersInjured &&
                          form.touched.rescuersInjured
                        }
                      >
                        <FormLabel>Ratowników rannych</FormLabel>
                        <Input
                          type={"number"}
                          {...field}
                          placeholder="Liczba"
                        />
                        <FormErrorMessage>
                          {form.errors.rescuersInjured}
                        </FormErrorMessage>
                      </FormControl>
                    )}
                  </Field>
                  <Field name="bystandersKilled">
                    {({ field, form }) => (
                      <FormControl
                        id="bystandersKilled"
                        isRequired
                        isInvalid={
                          form.errors.bystandersKilled &&
                          form.touched.bystandersKilled
                        }
                      >
                        <FormLabel>Osoby postronne zabite</FormLabel>
                        <Input
                          type={"number"}
                          {...field}
                          placeholder="Liczba"
                        />
                        <FormErrorMessage>
                          {form.errors.bystandersKilled}
                        </FormErrorMessage>
                      </FormControl>
                    )}
                  </Field>
                  <Field name="bystandersInjured">
                    {({ field, form }) => (
                      <FormControl
                        id="bystandersInjured"
                        isRequired
                        isInvalid={
                          form.errors.bystandersInjured &&
                          form.touched.bystandersInjured
                        }
                      >
                        <FormLabel>Osoby postronne ranne</FormLabel>
                        <Input
                          type={"number"}
                          {...field}
                          placeholder="Liczba"
                        />
                        <FormErrorMessage>
                          {form.errors.bystandersInjured}
                        </FormErrorMessage>
                      </FormControl>
                    )}
                  </Field>
                </SimpleGrid>
              </SimpleGrid>

              <Button
                mt={4}
                colorScheme="red"
                isLoading={isSubmitting}
                type="submit"
              >
                Wyślij
              </Button>
            </Form>
          )}
        </Formik>
      </Card>
    </Flex>
  );
}

export default Page;
